module.exports = __webpack_public_path__ + "assets/img/title_3.6fcd10c5.png";